import styled, { keyframes } from "styled-components/macro";

const onLoadAnimation = keyframes`
    0%{ opacity: 0; }
    100% { opacity: 1;}
`;

export const OverlayImageContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: #f7f4f0;
    z-index: 5;
    animation-name: ${onLoadAnimation};
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
`;
